import { RequestError } from '../requestError';
import api from '../axiosBase';
import { getURL } from '../serviceHelper';
import { getEnv } from '../../AppConfigs';
import { courseStatus, requestStatus } from '../../constants/statusConstants';

const SPSiteId = getEnv('REACT_APP_SP_SITE_ID');
const SPCourseListId = getEnv('REACT_APP_TRAINING_COURSE_SP_LIST_ID');
const SPRegistrationListId = getEnv('REACT_APP_TRAINING_COURSE_REGISTRATION_SP_LIST_ID');
const SPPlanListId = getEnv('REACT_APP_TRAINING_PLAN_SP_LIST_ID');

const expand = 'expand=fields(select=Title, eStartDate, eEndDate, eContent, eLocation, eTeacher, eNoOfTrainee, eApprovedBy, eApprovedDate,eApprovedStatus,eApprovedComment, eStatus,eReviewedBy, eReviewedDate, eReviewedStatus, eReviewComment, eNotes)';
const registrationExpand = 'expand=fields(select=Title, eEmployeeId, eCourseId, eEmployeeData)';
const planExpand = 'expand=fields(select=Title, PlanCode, eApprovedBy,eApprovedDate,eApprovedComment,eStatus)';

export class TrainingService {

  static async getTrainingPlanByStatus(status: string) {
    let filter = `filter=fields/eStatus eq '${status}'`;
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPPlanListId}/items?${planExpand}&${filter}`))
      .then(res => res.data.value)
      .catch(err => { throw new RequestError(err) });
  }

  static async getTrainingPlanById(id: any) {
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPPlanListId}/items/${id}?${planExpand}`))
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static async getTrainingPlanByApprover(email: string) {
    let filter = `filter=((startswith(fields/eApprovedBy,'${email.toLowerCase()}') and fields/eApprovedDate eq null and fields/eStatus eq '${requestStatus.submitted}'))`;
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPCourseListId}/items?${planExpand}&${filter}`))
      .then(res => res.data.value)
      .catch(err => { throw new RequestError(err) });
  }

  static async addTrainingPlan(trainingPlan: any) {
    return api.post(getURL(`/sites/${SPSiteId}/lists/${SPPlanListId}/items`), trainingPlan)
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static async updateTrainingPlan(id: any, fields: any) {
    return api.patch(getURL(`/sites/${SPSiteId}/lists/${SPPlanListId}/items/${id}/fields`), fields)
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static async getTrainingCourseByApprover(email: string) {
    let filter = `filter=((startswith(fields/eApprovedBy,'${email.toLowerCase()}') and fields/eApprovedDate eq null and fields/eStatus eq '${courseStatus.waitingapproval}') or (startswith(fields/eReviewedBy,'${email.toLowerCase()}') and fields/eReviewedDate eq null and fields/eStatus eq '${courseStatus.waitingreview}'))`;
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPCourseListId}/items?${expand}&${filter}`))
      .then(res => res.data.value)
      .catch(err => { throw new RequestError(err) });
  }
  static async getToolTechnologyCode(toolcode: string) {
    let filter = `filter=fields/eToolCode eq '${toolcode}'`;
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPCourseListId}/items?${expand}&${filter}`))
      .then(res => res.data.value)
      .catch(err => { throw new RequestError(err) });
  }

  static async getTrainingCourseByPlanCode(plancode: string) {
    let filter = `filter=fields/ePlanCode eq '${plancode}'`;
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPCourseListId}/items?${expand}&${filter}`))
      .then(res => res.data.value)
      .catch(err => { throw new RequestError(err) });
  }

  static async getTrainingCourseByStatus(status: string) {
    let filter = `filter=fields/eStatus eq '${status}'`;
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPCourseListId}/items?${expand}&${filter}`))
      .then(res => res.data.value)
      .catch(err => { throw new RequestError(err) });
  }

  static async getTrainingCourseById(id: any) {
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPCourseListId}/items/${id}?${expand}`))
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static async addTrainingCourse(trainingCourse: any) {
    return api.post(getURL(`/sites/${SPSiteId}/lists/${SPCourseListId}/items`), trainingCourse)
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static async updateTrainingCourse(id: any, fields: any) {
    return api.patch(getURL(`/sites/${SPSiteId}/lists/${SPCourseListId}/items/${id}/fields`), fields)
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static async getTraineeByCourse(courseId: string) {
    let filter = `filter=fields/eCourseId eq '${courseId}'`;
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPRegistrationListId}/items?${registrationExpand}&${filter}`))
      .then(res => res.data.value.map((o: any) => ({ ...JSON.parse(o.fields.eEmployeeData) })))
      .catch(err => { throw new RequestError(err) });
  }

  static async getCourseByUser(userId: string) {
    let filter = `filter=fields/eEmployeeId eq '${userId}'`;
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPRegistrationListId}/items?${registrationExpand}&${filter}`))
      .then(res => res.data.value)
      .catch(err => { throw new RequestError(err) });
  }

  static async addTrainingCourseRegistration(registration: any) {
    return api.post(getURL(`/sites/${SPSiteId}/lists/${SPRegistrationListId}/items`), registration)
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

}